import { createFileRoute } from "@tanstack/react-router";
import { useJobTypeDrawerContext } from "@/utils/job-type-detail/job-type-drawer-context";
import { JobTypeActivitySection } from "./fullActivity";

export const Route = createFileRoute(
	"/_authenticated/(org-app)/_orgAdmin/org-admin/$orgId/configuration/jobTypes/$jobTypeId/activity",
)({
	component: OrgJobTypeActivityTab,
});

function OrgJobTypeActivityTab() {
	const { jobType } = useJobTypeDrawerContext();

	return (
		<div className="p-4">
			<JobTypeActivitySection jobType={jobType} />
		</div>
	);
}
